import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { logActivity, resolvePageName, getPageAction, isLoggedIn, shouldSkipPageLogging } from '../utils/activityLogger';

const ActivityLoggerProvider = ({ children }) => {
  const location = useLocation();
  const lastPageRef = useRef('');

  useEffect(() => {
    const pathname = location.pathname;
    if (!pathname || pathname === lastPageRef.current || !isLoggedIn() || shouldSkipPageLogging(pathname)) return;

    lastPageRef.current = pathname;

    const pageName = resolvePageName(pathname);
    const action = getPageAction(pathname);

    logActivity({
      action,
      target: pageName,
      page_url: pathname,
    });
  }, [location.pathname]);

  return children;
};

export default ActivityLoggerProvider;
